const GAME_ASSET_DIRECTORY_ALIASES = Object.freeze({
  pong3d: "pong3D",
});

export function resolveGameAssetDirectory(gameName) {
  if (typeof gameName !== "string" || !gameName) return null;
  return GAME_ASSET_DIRECTORY_ALIASES[gameName.toLowerCase()] || gameName;
}

export function getGameAssetBasePath(gameName) {
  const directory = resolveGameAssetDirectory(gameName);
  return directory ? `/games/${directory}` : null;
}
